import UserCurrentNextTripContainer from './UserCurrentNextTripContainer';

export default UserCurrentNextTripContainer;
